module.exports = new __parcel__URL__("arrow_gray.b01d5c81.svg").toString();